/**
 * Modal入口
 */

import React from 'react';
import ReactDOM from 'react-dom';
import Modal, { Props } from './Modal';
import Dialog from './Dialog';

export default class ModalPortal extends React.PureComponent<Props> {
  static defaultProps = Modal.defaultProps;

  componentDidMount() {
    const div = document.createElement('div');

    div.className = '__modal__';
    this.div = div;
    document.body.appendChild(this.div);

    this.forceUpdate();
  }

  componentWillUnmount() {
    if (this.div) {
      document.body.removeChild(this.div);
    }
  }

  div?: HTMLDivElement;

  static alert = Dialog.alert;

  static confirm = Dialog.confirm;

  static show = Dialog.show;

  static hide = Dialog.hide;

  render() {
    if (!this.div) {
      return null;
    }

    return ReactDOM.createPortal(<Modal {...this.props} />, this.div);
  }
}
